/*
 * @Author: yuehui
 * @Date: 2019-09-16 10:18:40
 * @LastEditTime: 2019-12-09 10:26:15
 * @LastEditors: yuehui
 * @Description: copy
 */
import Cookies from 'js-cookie'
// import { auth } from '@/plugins/Auth'

const v = '-v1'
// const TokenKey = `Admin-Token${v}`
const SystemCode = 'System-Code' + v
const DepartmentKey = 'Department-key' + v
const TokenKey = 'Admin-Token' + v
const UserIdKey = 'Admin-UserId' + v
const StaffIdKey = 'Admin-StaffId' + v
const HomeType = 'Admin-HomeType' + v

export function setHomeType(type) {
  console.log('set getHomeType = ' + type)
  return Cookies.set(HomeType, type)
}

export function getHomeType() {
  const count = Cookies.get(HomeType)
  console.log('get getHomeType = ' + count)
  return count || '0'
}

export function setStaffId(staffId) {
  return Cookies.set(StaffIdKey, staffId)
}

export function getStaffId() {
  if (process.env.VUE_APP_ENV === 'development') {
    return '1542'
  }
  return Cookies.get(StaffIdKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
  // return auth.setAuthToken(token)
}

export function getToken() {
  return Cookies.get(TokenKey)
  // return auth.getAuthToken()
}

export function setDepartment(department) {
  return Cookies.set(DepartmentKey, JSON.stringify(department))
}

export function getDepartment() {
  const departmentStr = Cookies.get(DepartmentKey)
  let department = {}
  if (departmentStr) {
    department = JSON.parse(departmentStr)
  }
  return department
}

export function setSystemCode(code) {
  return Cookies.set(SystemCode, code)
}

export function getSystemCode() {
  return Cookies.get(SystemCode)
}

export function setUserId(userId) {
  return Cookies.set(UserIdKey, userId)
}

export function getUserId() {
  return Cookies.get(UserIdKey)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
  // return auth.removeAuth()
}

export function removeTokenByKey(TokenKey) {
  return Cookies.remove(TokenKey)
}

export function setTokenByKey(token, TokenKey) {
  return Cookies.set(TokenKey, token, { expires: 2 })
}

export function getTokenByKey(TokenKey) {
  // if (process.env.VUE_APP_ENV === 'development') {
  //   return 'bc605aa4-78af-455c-ad93-ba25e7d2c60b'
  // }
  return Cookies.get(TokenKey)
}

export function removeAll() {
  document.cookie.split('; ').forEach(item => {
    const key = item.split('=')[0]
    Cookies.remove(key)
  })
}
